import { Button, Chip, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import CountdownTimer from 'components/CountdownTimer/CountdownTimer';
import { CircleCheckIcon, CircleCloseIcon, LockIcon } from 'components/Icons';
import PautaEleicaoModal, { IPautaEleicaoGenericProps } from 'components/PautaEleicaoModal/PautaEleicaoModal';
import { format, setSeconds } from 'date-fns';
import { AssembleiaPautaStatus } from 'enuns/AssembleiaPautaStatus';
import { AssembleiaStatus } from 'enuns/AssembleiaStatus';
import { TipoPauta } from 'enuns/TipoPauta';
import { AssessorRoutePath } from 'library/Routes';
import { AssembleiaContaAssociado } from 'models/AssembleiaContaAssociado';
import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { assembleiaAssessorActionsRefresh } from 'store/modules/AssembleiasAssessorActions';
import { IAssembleiasAssessorItens } from 'store/modules/AssembleiasAssessorReducer';
import { assembleiaAssociadoActionsRefresh } from 'store/modules/AssembleiasAssociadoActions';
import { IAssembleiaAssociadoPautaOpcao } from 'store/modules/AssembleiasAssociadoReducer';
import { modalsActionsOpen } from 'store/modules/ModalsActions';
import { IWSAssembleia } from 'store/modules/WSAssembleiasReducer';
import { IReducer } from 'store/Reducer';
import { getContasSelecionadasPeloUsuario, getPermitirVoto } from 'utils/AssembleiaUtils';
import { getUniqueKey } from 'utils/KeyUtils';
import InvertedChevronIcon from '../Icons/InvertedChevronIcon';
import AssembleiaPautaAssessorActionButtons from './AssembleiaPautaAssessorActionButtons';
import AssembleiaPautaAssociadoActionButtons from './AssembleiaPautaAssociadoActionButtons';
import { IPauta } from './AssembleiaPautas';
import AssembleiaPautaVotoPresencialActionButtons from './AssembleiaPautaVotoPresencialActionButtons';
import useStyles from './style';

export interface IAssembleiaPauta {
  totalContas?: number;
  totalPresentes?: number;
  expanded?: boolean,
  onChange?: (expanded: boolean) => void,
  pauta: IPauta,
  loadingPautas?: boolean,
  flgVotoPresencial?: boolean;
}

export const PautaVotoInvalido: number = -1;


const mapStateToProps = (state:IReducer) => {
  return {
    loadingPautas: state.assembleias.loadingPautas,
  };
};

const AssembleiaPauta = ({
  totalContas,
  totalPresentes,
  expanded,
  onChange,
  pauta,
  loadingPautas,
  flgVotoPresencial
}: IAssembleiaPauta) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [pautaStatus, setPautaStatus] = useState(pauta.status);
  const [expandedState, setExpandedState] = useState(
    pautaStatus === AssembleiaPautaStatus.Liberada &&
    (
      pauta.descricao ||
      pauta.itens.length > 0
    ) ?
      true : false
  );
  const isAssessorRoute = useRouteMatch(AssessorRoutePath);
  const [voto, setVoto] = useState<number>(PautaVotoInvalido);
  const { auth, assembleias, assembleiasAssessor } = useSelector((state: IReducer) => state);
  const dispatchAction = useDispatch();

  const handleExpanded = () => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    if (pautaStatus === AssembleiaPautaStatus.Liberada && !isExpanded) {
      return;
    }
    setExpandedState(isExpanded);
    if (expandedState && typeof onChange === 'function') {
      onChange(expandedState);
    }
  }

  const getVotoAtual = useCallback((): number | null => {
    if (pauta.votos && pauta.votos.length) {
      return pauta.votos[0].idItemPauta;
    }
    return PautaVotoInvalido;
  }, [pauta.votos]);

  const summaryIsDisabled = (): boolean => {
    if (isAssessorRoute) {
      return false;
    } else {
      return pautaStatus === AssembleiaPautaStatus.Liberada ||
        (!pauta.descricao && pauta.itens.length === 0) ? true : false;
    }
  }

  const handleVoto = (event: React.ChangeEvent<HTMLInputElement>) => {
    const novoVoto: string = (event.target as HTMLInputElement).value;
    setVoto(parseInt(novoVoto));
  }

  const getStatusChip = () => {
    const label: string = t('AssembleiaPauta.status.' + pautaStatus);
    let disabled: boolean = true;
    let className: string = '';
    let icon: ReactElement | undefined;
    if (pautaStatus === AssembleiaPautaStatus.Liberada) {
      disabled = false;
    }
    switch(pautaStatus) {
    case AssembleiaPautaStatus.Liberada:
      className = classes.statusChipLiberada;
      icon = <CircleCheckIcon className={classes.statusIconChipLiberada} />;
      break;
    case AssembleiaPautaStatus.Bloqueada:
      className = classes.statusChipBloqueada;
      icon = <LockIcon />;
      break;
    case AssembleiaPautaStatus.Encerrada:
      className = classes.statusChipEncerrada;
      icon = <CircleCloseIcon />;
      break;
    }
    return <Chip icon={icon} label={ label } color="primary" disabled={ disabled } className={className} />
  }

  const onCompletedContdown = useCallback(() => {
    setPautaStatus(AssembleiaPautaStatus.Encerrada);
    const assembleiaRefreshed = {
      id: isAssessorRoute ? assembleiasAssessor.evento!.id : assembleias.currentEvent!.idAssembleia,
      pautas: [
        {
          idPauta: pauta.idPauta,
          status: AssembleiaPautaStatus.Encerrada,
          tempoVotacao: 0,
          tempoRestante: 0
        }
      ]
    };
    if (isAssessorRoute) {
      dispatchAction(
        assembleiaAssessorActionsRefresh(assembleiaRefreshed as IWSAssembleia)
      );
    } else {
      dispatchAction(
        assembleiaAssociadoActionsRefresh(assembleiaRefreshed as IWSAssembleia)
      );
    }
  }, [setPautaStatus, dispatchAction, assembleiasAssessor, assembleias, isAssessorRoute, pauta]);

  const getTimer = useCallback((disabled: boolean) => {
    return (
      <CountdownTimer
        counter={pauta.tempoRestante || pauta.tempoVotacao || 0}
        color="secondary"
        className={ classes.timer }
        disabled={ disabled }
        onCompleted={ () => onCompletedContdown() }
      />
    );
  }, [pauta, classes.timer, onCompletedContdown]);
  
  const getTimeChip = useCallback(() => {
    let label: string = '00:00:00';
    let disabled: boolean = true;
    if (pautaStatus === AssembleiaPautaStatus.Liberada) {
      label = format(setSeconds(new Date(2020, 0, 1, 0, 0, 0), pauta.tempoRestante || pauta.tempoVotacao || 0), 'HH:mm:ss');
      disabled = false;
      return getTimer(disabled)
    }
    return (
      <Chip
        label={ label }
        color="secondary"
        className={ classes.timer }
        disabled={ disabled }
      />
    )
  }, [pautaStatus, getTimer, classes, pauta]);

  const pautaItemsEnabled = useCallback((): boolean => {
    return getPermitirVoto(assembleias && assembleias.currentEvent && assembleias.currentEvent.contasDisponiveis ? assembleias.currentEvent.contasDisponiveis : [], auth!.usuario!.cpfCnpj);
  }, [assembleias, auth])

  const opcoesDisabled = useCallback(() => {
    if (!flgVotoPresencial && !pautaItemsEnabled()) {
      return true;
    }
    const contasSelecionadas: AssembleiaContaAssociado[] = getContasSelecionadasPeloUsuario(assembleias && assembleias.currentEvent && assembleias.currentEvent.contasDisponiveis ? assembleias.currentEvent.contasDisponiveis : [], auth!.usuario!.cpfCnpj);
    const contasSemRestricoes: AssembleiaContaAssociado[] = contasSelecionadas.filter(it => !it.restricao);
    if (!flgVotoPresencial && (contasSelecionadas.length === 0 || contasSemRestricoes.length === 0)) {
      return true;
    }
    if (!flgVotoPresencial && !auth.usuario!.perfil.associadoRoute.assembleias.pautas.participar) {
      return true;
    }
    if (loading || loadingPautas || pautaStatus !== AssembleiaPautaStatus.Liberada) {
      return true;
    }
    return false;
  }, [pautaItemsEnabled, loading, pautaStatus, loadingPautas, assembleias, auth, flgVotoPresencial]);

  const hideOpcoesRadio = useCallback(() => {
    if ((isAssessorRoute && !flgVotoPresencial) || (assembleias && assembleias.currentEvent && assembleias.currentEvent.status !== AssembleiaStatus.Live)) {
      return true;
    }
    return false;
  }, [isAssessorRoute, flgVotoPresencial, assembleias]);

  const openModalDetalhesChapa = (item: IAssembleiaAssociadoPautaOpcao | IAssembleiasAssessorItens) => {

    const modalKey: string = getUniqueKey();
    dispatchAction(
      modalsActionsOpen(
        PautaEleicaoModal,
        {
          genericProps: {
            key: modalKey,
            item: item
          } as IPautaEleicaoGenericProps
        },
        modalKey
      )
    )
  }

  const onVotoError = useCallback(() => {
    setVoto(getVotoAtual() || PautaVotoInvalido);
  }, [setVoto, getVotoAtual]);

  useEffect(() => {
    if (pauta && typeof pauta.status === 'number') {
      setPautaStatus(pauta.status);
    }
  }, [pauta, setPautaStatus]);

  return (
    <ExpansionPanel
      className={classes.expansionPanel}
      expanded={ expandedState || pautaStatus === AssembleiaPautaStatus.Liberada }
      onChange={ handleExpanded() }
    >
      <ExpansionPanelSummary
        expandIcon={ !summaryIsDisabled() ? <InvertedChevronIcon /> : null }
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        disabled={ summaryIsDisabled() }
      >
        <Typography className={classes.title}>
          { pauta.titulo }
        </Typography>
        <div className={ classes.chips }>
          { getTimeChip() }
          { getStatusChip() }
        </div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={ classes.details }>
        <Typography className={ classes.descricao }>
          {
            pauta.descricao
          }
        </Typography>
        {
          pauta.itens && pauta.itens.length > 0 ? (
            <>
              <div className={classes.pautaRow}>
                <Typography>
                  {
                    t("AssembleiaPauta.direcionamento")
                  }
                </Typography>
              </div>
              <FormControl component="fieldset">
                <RadioGroup aria-label="gender" name="gender1" value={voto > -1 ? voto : getVotoAtual()} onChange={handleVoto}>
                  {
                    pauta.itens.sort(
                      (item: IAssembleiaAssociadoPautaOpcao | IAssembleiasAssessorItens, item2: IAssembleiaAssociadoPautaOpcao | IAssembleiasAssessorItens)=> item.ordem - item2.ordem
                    ).map(
                      (pautaItem: IAssembleiaAssociadoPautaOpcao | IAssembleiasAssessorItens, key: number) => {
                        const label = pautaItem.flgAbstencao ? t('AssembleiaPauta.itemAbstencao') : pautaItem.descricao;
                        return hideOpcoesRadio() ? (
                          <div className={classes.pautaRow} key={key}>
                            <FormLabel
                              className={classes.item}
                            >
                              { label }
                              {
                                pauta.tipoPauta === TipoPauta.Eleicao
                                && !pautaItem.flgAbstencao ?
                                <Button
                                  className={classes.buttonEleicao}
                                  variant="contained"
                                  onClick={ event => openModalDetalhesChapa( pautaItem ) }
                                >
                                  <Info color="primary" className={classes.iconButton}/> <b className={ classes.textButtonEleicao }>{t("AssembleiaPauta.eleicaoTextButtom")}</b>
                                </Button>
                                : 
                                null
                              }
                            </FormLabel>
                          </div>
                        ) : (
                          <div className={classes.pautaRow} key={key}>
                            <FormControlLabel
                              disabled={ opcoesDisabled() }
                              classes={{ label: classes.item }}
                              value={ pautaItem.idItemPauta }
                              control={ <Radio color="secondary" /> }
                              label={ label }
                              key={ key }
                            />
                            {
                              pauta.tipoPauta === TipoPauta.Eleicao
                              && !pautaItem.flgAbstencao ?
                              <Button
                                className={classes.buttonEleicaoAssociado}
                                variant="contained"
                                onClick={ event => openModalDetalhesChapa( pautaItem ) }
                              >
                                <Info color="primary" className={classes.iconButton}/> <b className={ classes.textButtonEleicao }>{t("AssembleiaPauta.eleicaoTextButtom")}</b>
                              </Button>
                              : 
                              null
                              }
                          </div>
                        );
                      }
                    )
                  }
                </RadioGroup>
              </FormControl>
            </>
          ) : null
        }
        <div className={ classes.acoes }>
          {
            isAssessorRoute ? 
              flgVotoPresencial ? (
                <AssembleiaPautaVotoPresencialActionButtons
                  loading={ loading }
                  setLoading={ setLoading }
                  pauta={ { ...pauta, status: pautaStatus } }
                  voto={ voto }
                />
              ) : (
                <AssembleiaPautaAssessorActionButtons
                  loading={ loading }
                  setLoading={ setLoading }
                  pauta={ { ...pauta, status: pautaStatus } }
                  voto={ voto }
                />
              ) :
            (
              <AssembleiaPautaAssociadoActionButtons
                totalContas={totalContas}
                totalPresentes={totalPresentes}
                loading={ loading }
                setLoading={ setLoading }
                pauta={ { ...pauta, status: pautaStatus } }
                voto={ voto }
                onVotoError={ onVotoError }
              />
            )
          }
        </div>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export default connect(mapStateToProps)(AssembleiaPauta)